type Props = {
    width?: number | string;
    height?: number | string;
    className?: string;
    style?: React.CSSProperties;
};

export function AchievementIcon({ width = 12, height = 12, className, style }: Props) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 12 12"
            fill="none"
            className={className}
            style={style}
        >
            <g style={{ mixBlendMode: "plus-darker" }}>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M3.4375 1C2.91973 1 2.5 1.41974 2.5 1.9375V2H1.5C0.947715 2 0.5 2.44772 0.5 3V4.5C0.5 5.60455 1.39543 6.5 2.5 6.5H2.83682C3.31272 7.5018 4.25051 8.24165 5.375 8.44435V9.75H4.625C4.27982 9.75 4 10.0298 4 10.375C4 10.7202 4.27982 11 4.625 11H7.375C7.7202 11 8 10.7202 8 10.375C8 10.0298 7.7202 9.75 7.375 9.75H6.625V8.44435C7.7495 8.24165 8.6873 7.5018 9.1632 6.5H9.5C10.6046 6.5 11.5 5.60455 11.5 4.5V3C11.5 2.44772 11.0523 2 10.5 2H9.5V1.9375C9.5 1.41974 9.08025 1 8.5625 1H3.4375ZM10.25 4.5C10.25 4.91422 9.9142 5.25 9.5 5.25H9.4912C9.49705 5.16745 9.5 5.08405 9.5 5V3.25H10.25V4.5ZM2.5 5.25C2.08579 5.25 1.75 4.91422 1.75 4.5V3.25H2.5V5C2.5 5.08405 2.50296 5.16745 2.50879 5.25H2.5Z"
                    fill="currentColor"
                />
                <path
                    d="M1.25 4.5C1.25 5.19036 1.80964 5.75 2.5 5.75H3.04492L3.00781 5.21484C3.00281 5.14399 3 5.07229 3 5V2.75H1.25V4.5ZM9 5C9 5.07236 8.9972 5.14415 8.99219 5.21484L8.9541 5.75H9.5C10.1903 5.75 10.75 5.19036 10.75 4.5V2.75H9V5ZM5.875 8.02637L5.46387 7.95215C4.5015 7.77867 3.69635 7.14458 3.28809 6.28516L3.15332 6H2.5C1.67158 6 1 5.32841 1 4.5V3C1 2.72386 1.22386 2.5 1.5 2.5H3V1.9375C3 1.69588 3.19588 1.5 3.4375 1.5H8.5625C8.80411 1.5 9 1.69588 9 1.9375V2.5H10.5C10.7762 2.5 11 2.72385 11 3V4.5C11 5.32841 10.3284 6 9.5 6H8.84766L8.71191 6.28516C8.30365 7.14457 7.49851 7.77867 6.53613 7.95215L6.125 8.02637V10.25H7.375C7.44406 10.25 7.5 10.3059 7.5 10.375C7.5 10.4441 7.44406 10.5 7.375 10.5H4.625C4.55595 10.5 4.5 10.444 4.5 10.375C4.5 10.306 4.55595 10.25 4.625 10.25H5.875V8.02637Z"
                    stroke="currentColor"
                    strokeOpacity="0.15"
                    style={{ mixBlendMode: "plus-darker" as React.CSSProperties["mixBlendMode"] }}
                />
            </g>
        </svg>
    );
}

export default AchievementIcon;